import React from 'react';
import PropTypes from 'prop-types';
import LineItemContentII from './LineItemContentII';
import Loading from '../Loading/Loading';
import EditableLinks from './EditableContent/EditableLinks';

import './LineItemII.scss';

const LineItemII = props => {
  if (props.isLoading) {
    return <Loading dark relative small />;
  }
  return (
    <React.Fragment>
      <div className="line-item-ii-content-wrapper">
        <LineItemContentII {...props} />
      </div>
      {props.isMobile && <EditableLinks {...props} />}
    </React.Fragment>
  );
};

LineItemII.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default LineItemII;



// WEBPACK FOOTER //
// ./src/client/js/view/components/LineItemII/LineItemII.js